import { Component, h, Host, Prop } from '@stencil/core';

@Component({
	tag: 'ds-arrow-button',
})
export class ArrowButton {
	@Prop({ reflect: true }) direction: 'left' | 'right' = 'left';
	@Prop({ reflect: true }) buttonColor:
		| 'white'
		| 'blue'
		| 'purple'
		| 'pink'
		| 'green'
		| 'yellow'
		| 'black'
		| 'gray' = 'white';

	render() {
		return (
			<Host class={`ds-bg-ishares-${this.buttonColor || 'white'}`}>
				{this.direction === 'left' ? (
					<i class="fa fa-chevron-left" aria-hidden="true"></i>
				) : (
					<i class="fa fa-chevron-right" aria-hidden="true"></i>
				)}
			</Host>
		);
	}
}
